"use client"

import { Heart, BookOpen, Users, Target } from "lucide-react"

export function ImpactSection() {
  const impacts = [
    {
      icon: BookOpen,
      title: "Quality Education",
      description: "Comprehensive schooling and vocational training for sustainable futures",
      stat: "100+",
      label: "Children in School",
    },
    {
      icon: Heart,
      title: "Nutritious Meals",
      description: "Three daily meals ensuring proper nutrition and health",
      stat: "5000+",
      label: "Meals Monthly",
    },
    {
      icon: Users,
      title: "Family Support",
      description: "Keeping children connected to families and communities",
      stat: "200+",
      label: "Families Supported",
    },
    {
      icon: Target,
      title: "Skill Development",
      description: "Apprenticeships and career training for independence",
      stat: "55+",
      label: "Graduates",
    },
  ]

  return (
    <section className="section-container bg-muted/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="mb-6">Our Impact in Numbers</h2>
          <p className="text-xl text-foreground/70 max-w-2xl mx-auto">
            Real transformation happens when we provide education, nutrition, and care. Here&apos;s how we&apos;re making a
            difference.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {impacts.map((impact, idx) => {
            const Icon = impact.icon
            return (
              <div
                key={idx}
                className="group p-8 bg-card rounded-xl border border-border hover:border-primary/50 hover:shadow-lg transition-all hover:-translate-y-1"
              >
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                  <Icon className="text-primary" size={24} />
                </div>
                <h3 className="text-lg font-semibold mb-2">{impact.title}</h3>
                <p className="text-foreground/70 text-sm mb-6">{impact.description}</p>
                <div className="pt-4 border-t border-border">
                  <div className="text-2xl font-bold text-primary mb-1">{impact.stat}</div>
                  <p className="text-xs text-foreground/60">{impact.label}</p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
